<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Employee Payroll Info Import</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of employee data" prepend-icon="mdi-file"
                        label="Employee Payroll Data" show-size flat rounded outlined dense
                        v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/import_employee_payroll_info.csv">
                        <v-btn :loading="loading3" :disabled="loading3" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <template v-if="load == true">
                    <v-data-table dense :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable"
                        :search="search" :loading="output_load"></v-data-table>
                </template>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        /*
      Defines the data used by the component
    */
        data() {
            return {
                file: null,
                statuslist: "",
                load: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                loading3: false,
                search: "",
                headers: [
                    { text: "Sr.NO", value: "serial_number" },
                    { text: "Emp Code", value: "emp_code" },
                    { text: "Mail Id", value: "official_email" },
                    { text: "PF No", value: "pf_no" },
                    { text: "UAN No", value: "uan_no" },
                    { text: "Last PF No", value: "last_pfno" },
                    { text: "Ifsc Code", value: "ifsc_code" },
                    { text: "Gratuity No", value: "gratuity_no" },
                    { text: "Account No", value: "account_no" },
                    { text: "Bank", value: "bank" },
                    { text: "Date Of Birth", value: "birthdate" },
                    { text: "Date Of Joining", value: "dateofjoining" },
                    { text: "Date Of Retirement", value: "dateofretirement" },
                    { text: "Employee Type", value: "employeetype" },
                    { text: "Gender", value: "gender" },
                    { text: "Is Currently Working", value: "iscurrentlyworking" },
                    { text: "Is Eligible For Increment?", value: "is_eligible_for_increment" },
                    { text: "Is Handicap?", value: "is_handicap" },
                    { text: "Is House Provided?", value: "is_house_provided" },
                    { text: "Is Car Provided?", value: "is_car_provided" },
                    { text: "Is Parmanant Salary Blocked", value: "is_parmanant_salary_blocked" },
                    { text: "Is Parmanant salary Slip Blocked", value: "is_parmanant_salary_slip_blocked" },
                    { text: "Employee Payment Section", value: "employee_payment_section" },
                ],
                output_load: false,
            };
        },

        methods: {
            submitFile() {
                if (this.file == null) {
                    this.showSnackbar("#b71c1c", "Please select the file!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();
                    //console.log(this.file.size)
                    formData.append("file", this.file);

                    //console.log(formData)
                    axios
                        .post("payroll/importPayRollEmpInfo", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.statuslist = res.data.statuslist;
                                this.load = true;
                                this.showSnackbar("#4caf50", "Import successfully");
                            }
                            else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                        .finally(() => {
                            this.output_load = false;
                        });
                    //     }
                }
            }, //end of the fuction

            /*
        Handles a change on the file upload
      */
        },
    };
</script>
<style scoped>
    .downbtn {
        float: right;
    }

    /* new css */
    table,
    th {
        padding: 10px;
        border: 1px solid black;
        border-collapse: collapse;
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .mandatory {
        color: red;
    }
    .downbtn{
        color:black !important;
    }
    .downbtn:hover{
        color:white !important;
    }
</style>
